import { HttpParams, HttpParamsOptions } from '@angular/common/http';

// https://stackoverflow.com/a/46078299/2174621
export class BarHttpParams extends HttpParams {
    constructor(
        /**This means this is a request that should pass the interceptor but happens in background*/
        public backgroundRequest = false,
        /**This means interception should be ommited*/
        public ommitInterceptor = false,
        options?: HttpParamsOptions
    ) {
        super(options);
    }
}
